import React, { memo, useState, Suspense, lazy } from "react";
import { selectCurrentUser } from "redux/app/selectors";
import { useSelector } from "react-redux";
import { Popover, Button, Avatar } from "@material-ui/core";
import { deleteAllCookies, clearLocalStorage } from "helpers";
import { adminApp } from "api/constants";
import { UserDefaultAvatar } from "icons";
import { User, Logout } from "icons";
import style from "./style.module.scss";

const LogoutConfirm = lazy(() => import("components/Modal"));

const getAvatarName = (fullName) => {
  const words = fullName.split(" ");
  const firstChar = words[0] ? words[0].substring(0, 1) : "";
  const secondChar = words[1] ? words[1].substring(0, 1) : "";
  const name = firstChar + secondChar;
  return name.toUpperCase();
};

export const AvatarImage = () => {
  const user = useSelector(selectCurrentUser);

  if (!user.imagePreviewPath && user.fullName) {
    return (
      <Avatar className={style["avatar-name"]}>
        {getAvatarName(user.fullName)}
      </Avatar>
    );
  } else {
    return (
      <img
        alt="user-avatar"
        src={user.imagePreviewPath || UserDefaultAvatar}
        className={style.userAvatar}
      />
    );
  }
};

const AvatarComponent = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [isOpenLogout, setIsOpenLogout] = useState(false);
  const open = Boolean(anchorEl);
  const user = useSelector(selectCurrentUser);

  const logout = () => {
    deleteAllCookies();
    clearLocalStorage();
    window.location.replace(adminApp);
  };
  return (
    <>
      <div
        className={style.userAvatar}
        spanor="default"
        onClick={(event) => setAnchorEl(event.currentTarget)}
        style={{ textTransform: "none" }}
      >
        <AvatarImage />
      </div>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        classes={{ paper: style.rootPopOver }}
      >
        <div className={style.userInfo}>
          <span>
            {!user.imagePreviewPath && user.fullName ? (
              <Avatar className={style["avatar-name"]}>
                {getAvatarName(user.fullName)}
              </Avatar>
            ) : (
              <img
                alt="user-avatar"
                src={user.imagePreviewPath || UserDefaultAvatar}
                className={style.userAvatar}
              />
            )}
          </span>
          <div className={style.userDetail}>
            <p className={style.userName}>{user.fullName}</p>
            <p className={style.userEmail}>{user.email}</p>
          </div>
        </div>
        <a
          className={style.dropdownItemLink}
          target="_blank"
          rel="noopener noreferrer"
          href={`${adminApp}/app/edit-profile`}
        >
          <Button className={style.logoutButton}>
            <User />
            <span>User profile</span>
          </Button>
        </a>
        <div className={style.dropdownItemLink}>
          <Button
            onClick={() => setIsOpenLogout(true)}
            className={style.logoutButton}
          >
            <Logout />
            <span>Log out</span>
          </Button>
        </div>
      </Popover>
      {isOpenLogout && (
        <Suspense fallback={<></>}>
          <LogoutConfirm
            title="Confirmation"
            content="Do you really want to log out from AI Cycle Data Platform ?"
            isOpen={isOpenLogout}
            setIsOpen={(value) => setIsOpenLogout(value)}
            handleSubmit={logout}
          />
        </Suspense>
      )}
    </>
  );
};

export default memo(AvatarComponent);
